/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index text-counter to autogenerate all the fragments and extensions
 * Used by "prepareTextCounters"
 */

import TextCounter from './text-counter/TextCounter'
export * from './text-counter/TextCounter'
export default TextCounter
